//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as authAction from '../action/authAction';


class Comp extends React.Component {

  componentDidMount() {
    this.props.authCheck();
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      if ( ((new Date()) - this.props.auth.datetime) > (60*1000) ) {
        this.props.authCheck();
      }
    }
  }

	render() {
		return null
	}
}

const mapStateToProps = (state) => {
	return {
    auth: state.auth,
	}
};
const mapDispatchToProps = dispatch => (
	bindActionCreators({
    ...authAction,
	}, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
